const PageContentWrapper = ({children, mb, px, className, boxShadow}) => {
    return (
        <div className="grid">
            <div className="col-12 glassmorphism no-focus">
                <div
                    className={`card ${className} ${px ? px : ''}`}
                    style={{
                        marginBottom: mb ? mb : 'inherit',
                        padding: 6,
                        borderRadius: '12px',
                    }}>
                    {children}
                </div>
            </div>
        </div>
    )
}

export default PageContentWrapper
